<template>
  <modal-template :name="modalName">
    <template slot="default">
      <div class="confirm-section-item">
        <div class="confirm-section-item__header">
          <font-awesome-icon class="current-area__icon" :icon="'chair'" />
          <h3>{{ $t("modal.choose_area.section") }}</h3>
        </div>
        <p>{{ sectionInfo.sectionName }}</p>
      </div>
      <div class="confirm-section-item">
        <div class="confirm-section-item__header">
          <font-awesome-icon class="current-area__icon" :icon="['far', 'ticket-alt']" />
          <h3>{{ $t("modal.choose_area.category") }}</h3>
        </div>
        <p>{{ sectionInfo.price }}</p>
      </div>
      <div class="confirm-section-item">
        <div class="confirm-section-item__header">
          <font-awesome-icon class="current-area__icon" :icon="'check-circle'" />
          <h3>{{ $t("modal.choose_area.availability") }}</h3>
        </div>
        <p>{{ sectionInfo.availability }}</p>
      </div>
    </template>
    <template slot="footer">
      <button v-if="!sectionInfo.soldOut"
        class="btn--inverted"
        @click="chooseSeatingArea"
        :disabled="sectionInfo.availability == $t('availability.sold_out')">
        {{ $t("buttons.choose_seats") }}
      </button>
      <button v-else class="btn--inverted" @click="close">{{ $t("buttons.ok") }}</button>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate";

export default {
  name: "modal-confirm-section",
  components: {
    ModalTemplate,
  },
  data() {
    return {
      modalName: "modal-confirm-section",
    };
  },
  props: {
    sectionInfo: {
      type: Object,
      required: false,
    },
  },
  methods: {
    close() {
      this.$modal.hide(this.modalName);
    },
    chooseSeatingArea() {
      this.$emit("chooseSeatingArea");
    },
  },
};
</script>
